import { createActionTypeModel } from "../../../../store/global/action-model";

export const BookingSettingsData = createActionTypeModel("BookingSettingsData");
export const UpdateBookingStatus = "UpdateBookingStatus";
export const SaveBookingStatus = "SaveBookingStatus";
export const CreateBookingStatus = "CreateBookingStatus";
export const RemoveBookingStatus = "RemoveBookingStatus";

export const InsertTravelOption = "InsertTravelOption";
export const UpdateTravelOption = "UpdateTravelOption";
export const DeleteTravelOption = "DeleteTravelOption";

export const TravelOption = createActionTypeModel("TravelOption");

export const SaveConf = "SaveConf";
export const UpdateConf = "UpdateConf";

export const UpdateCustomField = "UpdateCustomField";
export const AddCustomField = "AddCustomField";
export const DeleteCustomField = "DeleteCustomField";

export const LocalDetailsType = createActionTypeModel("LocalDetailsType");
export const LocalDetailsTypeField = createActionTypeModel(
  "LocalDetailsTypeField"
);

export const InvoiceItem = createActionTypeModel("InvoiceItem");

export const InvoiceGroups = createActionTypeModel("InvoiceGroups");
export const InvoiceGroupItems = createActionTypeModel("InvoiceGroupItems");

export const SharingData = createActionTypeModel("SharingData");
export const RssList = createActionTypeModel("RssList");
export const DEFAULT_LOCK_JSON = createActionTypeModel("DEFAULT_LOCK_JSON");
// export const TaskTemplate = createActionTypeModel("TaskTemplate");
// export const TaskTemplateGroup = createActionTypeModel("TaskTemplateGroup");
// export const TaskTemplateGroupItems = createActionTypeModel("TaskTemplateGroupItems");
